import { styled } from "../../../styled-components";

export const AddToHomeWrapper = styled.div`
    position: absolute;

    left: 0;
    right: 0;
    bottom: 0;
    top: 0;

    background-color: rgba(0, 0, 0, 0.3);

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 50;
`;

export const AddToHomeWindow = styled.div`
    position: relative;
    width: calc(100% - 40px);
    min-width: 60%;
    padding: 20px;

    background-color: ${p => p.theme.offBaseColor};
    border-radius: 12px;

    display: flex;
    flex-direction: column;

    align-items: center;
`;

export const Title = styled.div`
    ${p => p.theme.fontStyles.AccentHeader4}
    text-align: center;
    margin: 10px 0;
    color: ${p => p.theme.fgColorDark};
`;

export const Description = styled.div`
    ${p => p.theme.fontStyles.Body5};
    text-align: center;
    margin-bottom: 10px;
    color: ${p => p.theme.fgColorMedium};
`;

export const CallToAction = styled.div`
    ${p => p.theme.fontStyles.Body5};
    text-align: center;
    color: ${p => p.theme.fgColorDark};
`;

export const CloseButton = styled.div`
    position: absolute;

    width: 56px;
    height: 56px;

    top: 0;
    right: 0;

    display: flex;
    align-items: center;
    justify-content: center;
    color: ${p => p.theme.fgColorDark};
`;
